import { render, staticRenderFns } from "./SingleDashboard.vue?vue&type=template&id=9c0e5ea4&"
import script from "./SingleDashboard.vue?vue&type=script&lang=js&"
export * from "./SingleDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports